// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
  font-family: 'Poppins', sans-serif !important;
}

.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}


.main-container {
  background-color: #45115f;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  color: white;
}

.app-logo {
  width: 150px; /* Adjust the size of your logo */
  height: 150px; /* Adjust the size of your logo */
  border-radius: 15px;
}

.app-logo-nav {
  width: 50px; /* Adjust the size of your logo */
  height: 50px; /* Adjust the size of your logo */
  border-radius: 15px;
  margin: 5px;
}

.app-name {
  font-size: 46px;
  margin: 10px 0;
  font-weight: 600;
}
.note {
  margin: 20px;
  border: solid 1px white;
  border-radius: 10px;
  padding: 30px;
  background-color: rgba(255, 255, 255, 0.197);
}

.note p{
  font-size: 16px;
  font-weight: bold;
}

.track-body{
  width: 100%;
}

.driver-body{
  /* border-radius: 10px; */
  background-color: white;
  /* width: 100%; */
  padding: 10px 30px;
}

.title{
  color: #52007a;
  font-size: 20px;
  margin-bottom: 5px;
}

.driver-body img{
  padding-right: 5px;
}

.driver-body .name{
  padding: 0px 5px;
  font-weight: bold;
  font-size: 16px;
}

.driver-body .mobile{
  padding-left: 5px;
  font-weight: bold;
  font-size: 12px;
  color: #f21c1c
}

.driver-body .vehicle{
  padding-left: 5px;
  font-size: 14px;
  color : gray
}
p:first-letter {text-transform:capitalize;}

.row-md{
  display: flex;
}

.divider-md{
  border-right: 1px solid #45115f
}

.profile-img{
  width: 65px;
  height: 65px;
  object-fit: cover;
  border-radius: 50%;
}

@media (max-width: 767px) {
  .row-md{
    display: block;
  } 

  .divider-md{
    border-right: none;
    border-bottom: 1px solid #45115f;
  }

  .driver-body{
    padding: 10px 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,YAAY,EAAE,iCAAiC;EAC/C,aAAa,EAAE,iCAAiC;EAChD,mBAAmB;AACrB;;AAEA;EACE,WAAW,EAAE,iCAAiC;EAC9C,YAAY,EAAE,iCAAiC;EAC/C,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf;AACF;AACA,gBAAgB,yBAAyB,CAAC;;AAE1C;EACE,aAAa;AACf;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["body{\n  font-family: 'Poppins', sans-serif !important;\n}\n\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n.main-container {\n  background-color: #45115f;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  text-align: center;\n  color: white;\n}\n\n.app-logo {\n  width: 150px; /* Adjust the size of your logo */\n  height: 150px; /* Adjust the size of your logo */\n  border-radius: 15px;\n}\n\n.app-logo-nav {\n  width: 50px; /* Adjust the size of your logo */\n  height: 50px; /* Adjust the size of your logo */\n  border-radius: 15px;\n  margin: 5px;\n}\n\n.app-name {\n  font-size: 46px;\n  margin: 10px 0;\n  font-weight: 600;\n}\n.note {\n  margin: 20px;\n  border: solid 1px white;\n  border-radius: 10px;\n  padding: 30px;\n  background-color: rgba(255, 255, 255, 0.197);\n}\n\n.note p{\n  font-size: 16px;\n  font-weight: bold;\n}\n\n.track-body{\n  width: 100%;\n}\n\n.driver-body{\n  /* border-radius: 10px; */\n  background-color: white;\n  /* width: 100%; */\n  padding: 10px 30px;\n}\n\n.title{\n  color: #52007a;\n  font-size: 20px;\n  margin-bottom: 5px;\n}\n\n.driver-body img{\n  padding-right: 5px;\n}\n\n.driver-body .name{\n  padding: 0px 5px;\n  font-weight: bold;\n  font-size: 16px;\n}\n\n.driver-body .mobile{\n  padding-left: 5px;\n  font-weight: bold;\n  font-size: 12px;\n  color: #f21c1c\n}\n\n.driver-body .vehicle{\n  padding-left: 5px;\n  font-size: 14px;\n  color : gray\n}\np:first-letter {text-transform:capitalize;}\n\n.row-md{\n  display: flex;\n}\n\n.divider-md{\n  border-right: 1px solid #45115f\n}\n\n.profile-img{\n  width: 65px;\n  height: 65px;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n@media (max-width: 767px) {\n  .row-md{\n    display: block;\n  } \n\n  .divider-md{\n    border-right: none;\n    border-bottom: 1px solid #45115f;\n  }\n\n  .driver-body{\n    padding: 10px 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
